/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Carousel from './modules/carousel';
import DocumentContent from './modules/document-content';
import Header from './modules/header';
import Hero from './modules/hero';
import HorseTable from './modules/horse-table';
import Modal from './modules/modal';
import Nav from './modules/nav';
import NavItem from './modules/nav-item';
import SponsorsCarousel from './modules/sponsors-carousel';
import Table from './modules/table';
import TypeMate from 'typemate';
import ViewportVisible from './modules/viewport-visible';

/*------------------------------------*
    APP
\*------------------------------------*/
const app = {

    init() {
        this.noJs();
        this.alwaysLoad();
        this.bind();
    },

    bind() {

        // Load any items that need modules
        let modulePlaceHolders = [...document.querySelectorAll('[data-module]')];

        // No modules so bail
        if (!modulePlaceHolders.length) {
            return;
        }

        modulePlaceHolders.map((item) => {

            // Attempt to load any modules
            let modules = item.getAttribute('data-module');

            if (!modules.length) {
                return false;
            }

            // Split the modules into an array
            modules = modules.trim().split(',');

            // Loop and bind to relevant modules
            modules.map((module) => {

                switch (module.trim()) {
                    case 'carousel':

                        let carouselInstance = new Carousel(item);

                        carouselInstance.init();

                        break;
                    
                    case 'document-content':
                        
                        let documentContentInstance = new DocumentContent(item);

                        documentContentInstance.init();

                        break;
                    
                    case 'header':

                        let headerInstance = new Header(item);

                        headerInstance.init();

                        break;
                    
                    case 'hero':

                        let heroInstance = new Hero(item);

                        heroInstance.init();

                        break;
                    
                    case 'horse-table':

                        let horseTableInstance = new HorseTable(item);

                        horseTableInstance.init();

                        break;
                    
                    case 'modal':

                        let modalInstance = new Modal(item);

                        modalInstance.init();

                        break;
                    
                    case 'nav':

                        let navInstance = new Nav(item);

                        navInstance.init();

                        break;
                    
                    case 'nav-item':

                        let navItemInstance = new NavItem(item);

                        navItemInstance.init();

                        break;
                    
                    case 'sponsors-carousel':

                        let sponsorsCarouselInstance = new SponsorsCarousel(item);

                        sponsorsCarouselInstance.init();

                        break;
                    
                    case 'table':

                        let tableInstance = new Table(item);

                        tableInstance.init();

                        break;
                    
                    case 'viewport-visible':

                        let viewportVisibleInstance = new ViewportVisible(item);

                        viewportVisibleInstance.init();

                        break;
                }
            });
        });
    },

    alwaysLoad() {
        // Typemate
        const typeMateInstance = new TypeMate(document.body, {
            selector: 'h1, h2, h3, p'
        });
        typeMateInstance.apply();
    },

    noJs() {
        document.documentElement.classList.remove('no-js');
        document.documentElement.classList.add('js');
    }
};

// Launch
app.init();